import React, { Component } from 'react';
import Swiper from 'swiper';
import SwiperItem from './item';
import 'swiper/css/swiper.min.css' // 引入样式
import './index.css'
import styles from './index.module.scss'
import defaultSetting from '@/setting'

class Slider extends Component {
  componentDidMount(){
    this.setScale()
    window.onresize = () => {
       this.setScale()
    }
     setTimeout(function(){
        new Swiper('.swiper-container', {
            loop: true,
            autoplay: false,
            // pagination: {
            //     el: '.swiper-pagination',
            //     clickable :true,
            // },
            // navigation: {
            //     nextEl: '.swiper-button-next', // 右按钮
            //     prevEl: '.swiper-button-prev', // 左按钮
            // }
        });
     },500)
  }
  setScale() {
    if(devicePixelRatio > 1 && devicePixelRatio < 2) {
        const result = 1 - Math.abs(devicePixelRatio - 1) + 0.1
        document.getElementById('handle-wrap').style.transform = `translateX(-50%) scale(${result})`
    } else if (devicePixelRatio === 2) {
        document.getElementById('handle-wrap').style.transform = `translateX(-50%) scale(0.9)`
    } else if (devicePixelRatio > 2 && devicePixelRatio < 3) {
        const result = 1 - Math.abs(devicePixelRatio - 2)
        document.getElementById('handle-wrap').style.transform = `translateX(-50%) scale(${result})`
    } else if (devicePixelRatio === 3) {
        document.getElementById('handle-wrap').style.transform = `translateX(-50%) scale(0.5)`
    } else if ( devicePixelRatio > 3 && devicePixelRatio < 3.5) {
        const result = 0.6 - Math.abs(devicePixelRatio - 3)
        document.getElementById('handle-wrap').style.transform = `translateX(-50%) scale(${result})`
    } else {
        document.getElementById('handle-wrap').style.transform = `translateX(-50%) scale(1)`
    }
    }
  doScroll = () => {
    const bannerHeight = document.getElementById('swiper-container').clientHeight
    window.scrollTo({
        top: bannerHeight,
        behavior: "smooth"
    });
  }
  render(){
    return (
        <div className={`swiper-container ${styles.swiper}`} id="swiper-container">
            <div className="swiper-wrapper lx-relative">
                <SwiperItem list={this.props.list}></SwiperItem>
            </div>

            <div className="handle-wrap" id="handle-wrap">
                {/* <div className="handle-title lx-text-center">
                    中国中化2023年校园招聘
                </div> */}
                {/*<a href={`/${defaultSetting.suiteKey}/pb/school.html`} className="handle-btn lx-flex-row-center lx-pointer" rel="noreferrer">*/}
                {/*    <span className="handle-btn-text lx-relative lx-fz16 lx-text-color-white">中国中化2025年校园招聘</span>*/}
                {/*    <span className="loader"></span>*/}
                {/*    <img className='tip-hand' src={require('@/assets/images/hander.png')}></img>*/}
                {/*</a>*/}

                <div className="slide-top-wrap lx-relative lx-flex-column-center lx-pointer" onClick={() => this.doScroll()}>
                    <div className="slide-icon lx-mb10 lx-flex-row-center">
                        <svg className="arrow-bottom-icon" viewBox="0 0 1045 1024" width="20" height="20"><path fillRule="evenodd" d="M579.54 718.979l339.881-339.881-61.004-61.004-339.88 339.88L187.37 326.81l-61.004 61.004 392.17 392.17 61.004-61.004z"></path></svg>
                    </div>
                    <div className="lx-fz16 lx-text-color-placeholder">向下滑动</div>
                </div>
            </div>
            {/* <div className="swiper-pagination"></div> */}
            {/* <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div> */}
        </div>
        )
    }
}


class App extends Component {
  render(){
    return <div>
        <Slider></Slider>
    </div>
  }
}



export default App;